import React from "react";

import Table from "@material-ui/core/Table";
import PropTypes from "prop-types";

import useRbTableStyles from "./useRbTableStyles";

const RbTable = React.forwardRef(function RbTable(props, ref) {
  const { children, variant, ...other } = props;

  const classes = useRbTableStyles(props);

  return (
    <Table {...other} ref={ref} classes={classes}>
      {children}
    </Table>
  );
});

RbTable.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(["default", "striped", "card"]),
};

RbTable.defaultProps = {
  children: null,
  variant: "default",
};

export default React.memo(RbTable);
